'use client';

import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { motion } from 'framer-motion';
import { useTheme } from '@/contexts/ThemeContext';

export default function ThemeToggle() {
    const { theme, toggleTheme } = useTheme();

    return (
        <button
            onClick={toggleTheme}
            className="relative h-11 w-14 rounded-full border border-border bg-card/80 p-1 transition-colors hover:bg-card"
            aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
        >
            <motion.div
                className={`flex h-8 w-8 items-center justify-center rounded-full ${theme === 'dark'
                        ? 'bg-secondary'
                        : 'bg-accent'
                    }`}
                animate={{ x: theme === 'dark' ? 0 : 16 }}
                transition={{ type: 'spring', stiffness: 500, damping: 30 }}
            >
                {theme === 'dark' ? (
                    <Moon size={15} className="text-secondary-foreground" />
                ) : (
                    <Sun size={15} className="text-accent-foreground" />
                )}
            </motion.div>
        </button>
    );
}
